
import { defineComponent, PropType } from 'vue'

import { FullWidthTextBlock, SummitLightSpeedVideoBlock, SummitWistiaVideoBlock, SummitQuizBlock } from '@/CMS/types/blocks'

import QSummitFullScreenLayout from './layouts/FullScreen.vue'
import QSummitStripedLayout from './layouts/Striped.vue'
import QSummitCinemaLayout from './layouts/Cinema.vue'

import QSummitWistiaPlayer from '@/CMS/views/ContentBlocks/Elements/QSummitWistiaPlayer.vue'
import QSummitLightSpeedPlayer from '@/CMS/views/ContentBlocks/Elements/QSummitLightSpeedPlayer.vue'
import QSummitQuiz from '@/FML/views/index-quiz.vue'


export default defineComponent({
    props: {
        step: { type: Object as PropType<{
            StepConfig: {
                content: SummitLightSpeedVideoBlock | SummitWistiaVideoBlock | FullWidthTextBlock | SummitQuizBlock
            },
            StepType: string,
        }>, required: true },
    },

    components: {
        QSummitFullScreenLayout,
        QSummitStripedLayout,
        QSummitCinemaLayout,
        QSummitWistiaPlayer,
        QSummitLightSpeedPlayer,
        QSummitQuiz,
    },

    computed: {
        layout() {
            if (this.step.StepType === 'Skill Block') {
                return (this.$vuetify as any).breakpoint.smAndDown ? 'QSummitStripedLayout' : 'QSummitCinemaLayout'
            }
            return 'QSummitFullScreenLayout'
        },
        content_type() {
            return this.step.StepConfig.content.type
        }
    },

    methods: {
        isNoText(text: string) {
            return !text || text === '<p></p>'
        }
    },
})
